(function (globalScope) {
  'use strict';

  function normalizeImageUrl(value) {
    const normalized = String(value || '').trim();
    return normalized.indexOf('//') === 0 ? 'https:' + normalized : normalized;
  }

  function normalizeProductData(input) {
    const source = input && typeof input === 'object' ? input : {};
    return {
      productId: String(source.productId || source.id || '').trim(),
      variantId: String(source.variantId || '').trim(),
      handle: String(source.handle || '').trim(),
      title: String(source.title || '').trim(),
      imageUrl: normalizeImageUrl(source.imageUrl || source.image),
      priceCents: Number.isSafeInteger(source.priceCents) ? source.priceCents : Math.round((Number(source.price) || 0) * 100),
      color: String(source.color || '').trim(),
      size: String(source.size || 'N/A').trim() || 'N/A',
      swatchUrl: normalizeImageUrl(source.swatchUrl || source.colorImage)
    };
  }

  function storeFallback(storage, product) {
    let products;
    try { products = JSON.parse(storage.getItem('showroom_products') || '[]'); }
    catch (error) { products = []; }
    if (!Array.isArray(products)) products = [];
    const exists = products.some((item) => String(item.variantId) === product.variantId && String(item.size || 'N/A') === product.size);
    if (!exists) products.push(Object.assign({}, product, {
      id: Date.now(), image: product.imageUrl, price: product.priceCents / 100, colorImage: product.swatchUrl, syncPending: true
    }));
    storage.setItem('showroom_products', JSON.stringify(products));
    return { created: !exists, pending: true };
  }

  async function requestJson(fetchRequest, url, options) {
    const response = await fetchRequest(url, options);
    let payload;
    try { payload = await response.json(); } catch (error) { payload = null; }
    if (!response.ok || !payload || !payload.ok) {
      const requestError = new Error(payload && payload.message ? payload.message : 'Showroom synchronization is temporarily unavailable.');
      requestError.code = payload && payload.code;
      requestError.status = response.status;
      throw requestError;
    }
    return payload.data;
  }

  async function addProduct(input, dependencies) {
    const config = dependencies.config || {};
    const product = normalizeProductData(input);
    if (!config.loggedIn || !config.showroomId) {
      const error = new Error('Please log in to add styles to your Showroom.');
      error.code = 'LOGIN_REQUIRED';
      throw error;
    }
    const endpoint = String(config.endpoint || '/apps/chicsew-showroom/api/showrooms').replace(/\/$/, '');
    const showroomUrl = endpoint + '/' + encodeURIComponent(config.showroomId);
    const productOptions = {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(product)
    };
    try {
      let data;
      try {
        data = await requestJson(dependencies.fetch, showroomUrl + '/products', productOptions);
      } catch (error) {
        if (error.code !== 'SHOWROOM_NOT_FOUND') throw error;
        await requestJson(dependencies.fetch, showroomUrl + '/profile', {
          method: 'PATCH', credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: String(config.ownerName || 'My Showroom').trim() || 'My Showroom',
            eventLocation: '',
            eventDate: null
          })
        });
        data = await requestJson(dependencies.fetch, showroomUrl + '/products', productOptions);
      }
      return Object.assign({ pending: false }, data);
    } catch (error) {
      if (error.code === 'LOGIN_REQUIRED' || error.code === 'FORBIDDEN' || (error.status && error.status < 500 && error.code !== 'SHOWROOM_NOT_FOUND')) throw error;
      return storeFallback(dependencies.storage, product);
    }
  }

  const api = {
    add(product) {
      return addProduct(product, {
        config: globalScope.ChicSewShowroomProductConfig || {},
        fetch: globalScope.fetch.bind(globalScope),
        storage: globalScope.localStorage
      });
    }
  };
  globalScope.ChicSewShowroomProduct = api;

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { addProduct, normalizeImageUrl, normalizeProductData, requestJson, storeFallback };
  }
})(typeof window !== 'undefined' ? window : globalThis);
